import { Pipe, PipeTransform } from '@angular/core';
import { AvanoButtonBarGroup, AvanoButtonBarButtonDetails } from './avano-button-bar.common';

@Pipe({
  name: 'avanoButtonBarButtonGroup'
})
export class AvanoButtonBarButtonGroup implements PipeTransform {
  transform(allButtons: AvanoButtonBarButtonDetails[], filterForGroup: AvanoButtonBarGroup): AvanoButtonBarButtonDetails[] {
    return allButtons.filter((singleBtn: AvanoButtonBarButtonDetails) => {
      if (filterForGroup === AvanoButtonBarGroup.PRIMARY) {
        return singleBtn.group === AvanoButtonBarGroup.PRIMARY || !singleBtn.group;
      } else {
        return singleBtn.group === filterForGroup;
      }
    });
  }
}
